export default __webpack_public_path__ + "static/media/illustration-work-2-m@3x.9903f4ec.webp";